import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Authenticator, useTheme, View, Text, Heading, useAuthenticator, Button, Image } from '@aws-amplify/ui-react';
import { Amplify } from 'aws-amplify';
import outputs from '../amplify_outputs.json';
import '@aws-amplify/ui-react/styles.css';
import { I18n } from 'aws-amplify/utils';
import { translations } from '@aws-amplify/ui-react';

I18n.putVocabularies(translations)
I18n.setLanguage('pt')

// Importando as páginas
import Home from './pages/Home';
import NovaSolicitacao from './pages/NovaSolicitacao';
import MinhasSolicitacoes from './pages/MinhasSolicitacoes';
import Gerenciamento from './pages/Gerenciamento';
import DetalhesSolicitante from './pages/DetalhesSolicitante';
import DetalhesGerenciamento from './pages/DetalhesGerenciamento';
import EdicaoSolicitante from './pages/EdicaoSolicitante';
import Projetos from './pages/Projetos';
import Materiais from './pages/Materiais';
import Analises from './pages/Analises';
import { useEffect, useState } from 'react';
import { fetchUserAttributes } from 'aws-amplify/auth';

Amplify.configure(outputs);

I18n.putVocabularies({
  pt: {
    'Email': 'Email'
  }
})

const components = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Image
          alt="Logo ITEMM"
          src="https://eletrico.labsitemm.com/static/media/logo-itemm-1.133c649f79bf5f4bf542.png"
          width={300}
        /> 
      </View>
    );
  },

  Footer() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Text color={tokens.colors.neutral[80]}>
          &copy; Developed by CISA | ITEMM
        </Text>
      </View>
    );
  },

  SignIn: {
    Header() {
      return (
        <Heading
          paddingTop={40}
          paddingBottom={5}
          level={4}
          textAlign='center'
        >
          Laboratório Físico-Químico
        </Heading>
      );
    },
    Footer() {
      const { toForgotPassword } = useAuthenticator();

      return (
        <View textAlign="center">
          <Button
            fontWeight="normal"
            onClick={toForgotPassword}
            size="small"
            variation="link"
          >
            Esqueci minha senha
          </Button>
        </View>
      );
    },
  },
  SetupTotp: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Enter Information:
        </Heading>
      );
    },
    // Footer() {
    //   return <Text>Footer Information</Text>;
    // },
  },
  ConfirmSignIn: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Enter Information:
        </Heading>
      );
    },
    Footer() {
      return <Text>Footer Information</Text>;
    },
  },
  ForgotPassword: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Preencha as informações:
        </Heading>
      );
    },
    // Footer() {
    //   return <Text>Footer Information</Text>;
    // },
  },
  ConfirmResetPassword: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Preencha as informações:
        </Heading>
      );
    },
    // Footer() {
    //   return <Text>Footer Information</Text>;
    // },
  },
};

const formFields = {
  signIn: {
    username: {
      placeholder: 'Digite o seu email',
    },
    password: {
      label: 'Senha',
      placeholder: 'Digite a sua senha'
    }
  },
  forgotPassword: {
    username: {
      placeholder: 'Digite o seu email',
    },
  },
  confirmResetPassword: {
    confirmation_code: {
      placeholder: 'Digite o codigo de confirmação',
      label: 'Código',
      isRequired: false,
    },
    confirm_password: {
      placeholder: 'Confirme a nova senha',
    },
  },
  setupTotp: {
    QR: {
      totpIssuer: 'test issuer',
      totpUsername: 'amplify_qr_test_user',
    },
    confirmation_code: {
      label: 'New Label',
      placeholder: 'Enter your Confirmation Code:',
      isRequired: false,
    },
  },
  confirmSignIn: {
    confirmation_code: {
      label: 'New Label',
      placeholder: 'Enter your Confirmation Code:',
      isRequired: false,
    },
  },
};

const PrivateRoute = ({ children, allowedGroups }: any) => {
  const [userGroups, setUserGroups] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function handleFetchUserAttributes() {
      try {
        const userAttributes = await fetchUserAttributes();
        const groups = userAttributes['custom:group'] 
          ? userAttributes['custom:group'].split(',')
          : []; 

        console.log('User Groups:', groups); 
        setUserGroups(groups); 
      } catch (error) {
        console.error('Error fetching user attributes:', error);
        setUserGroups([]); 
      } finally {
        setLoading(false);
      }
    }

    handleFetchUserAttributes();
  }, []);

  if (loading) return null; // Ou um loading spinner, se preferir

  const hasAccess = allowedGroups.some((group: string) => userGroups.includes(group));
  console.log('User has access:', hasAccess); // Log para verificar acesso

  return hasAccess ? children : <Navigate to="/" />;
};

function App() {
  return (
    <Authenticator hideSignUp formFields={formFields} components={components}>
      {({  }) => (
        <Router>
          <main>
            {/* <header>
              <h1>Bem-vindo, {user?.username}!</h1>
              <button onClick={signOut}>Sair</button>
            </header> */}
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/novasolicitacao' element={<NovaSolicitacao />} />
              <Route path='/minhassolicitacoes' element={<MinhasSolicitacoes />} />
              <Route path='/minhassolicitacoes/detalhes/:id' element={<DetalhesSolicitante />} />
              <Route 
                path='/gerenciamento' 
                element={
                  <PrivateRoute allowedGroups={['ADMINS']}>
                    <Gerenciamento />
                  </PrivateRoute>
                  } 
                />
              <Route 
                path='/gerenciamento/detalhes/:id' 
                element={
                  <PrivateRoute allowedGroups={['ADMINS']}>
                    <DetalhesGerenciamento />
                  </PrivateRoute>
                } 
              />
              <Route path='/minhassolicitacoes/detalhes/:id/editar' element={<EdicaoSolicitante />} />
              <Route 
                path='/projetos' 
                element={
                  <PrivateRoute allowedGroups={['ADMINS']}>
                    <Projetos />
                  </PrivateRoute>
                } 
              />
              <Route 
                path='/materiais' 
                element={
                  <PrivateRoute allowedGroups={['ADMINS']}>
                    <Materiais />
                  </PrivateRoute>
                } 
              />
              <Route 
                path='/analises' 
                element={
                  <PrivateRoute allowedGroups={['ADMINS']}>
                    <Analises />
                  </PrivateRoute>
                } 
              />
            </Routes>
          </main>
        </Router>
      )}
    </Authenticator>
  );
}

export default App;
